import type { Joint } from "../../types/scene";

export const getScalarJointRef = (joint: Joint | null | undefined): number =>
  joint && (joint.kind === "hinge" || joint.kind === "slide") && Number.isFinite(joint.ref)
    ? joint.ref
    : 0;

export const getScalarJointRange = (joint: Joint | null | undefined): [number, number] | null =>
  joint && (joint.kind === "hinge" || joint.kind === "slide") && Array.isArray(joint.range)
    ? joint.range
    : null;
